import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, Renderer2, Inject } from '@angular/core';
import { BpmnViewerComponent } from '../bpmn-viewer.component/bpmn-viewer.component';
import { BpmnViewerService, UserClicksElementsService } from '../services/index';
import { InjectionNames } from '../../../app/shared/bpmn-io/bpmn-js';
import { BpmnGuidedBoxService } from '../services/bpmn-guided-box.service';
import { select, Store } from '@ngrx/store';
import {
  BP_Status,
  selectGetBpmnXmlParsingStatus, selectGetUserSelectionStatus,
  State,
  UpdateLatestSelectedNodeIdAction, UpdateUserSelectionStatusAction, USER_SELECTION_STATUS
} from '../store/index';
import { selectLatestSelectedNodeId } from '@ispm-client/modules/process-executor/store/selectors/latest-selected-node-id.selector';
import {MessageService} from "@wuitk/angular/components/notification";
import { TestService } from '@ispm/dashboard/test/services/test.service';

@Component({
  selector:    'ispm-bpmn-execution',
  templateUrl: '../bpmn-viewer.component/bpmn-viewer.component.html',
  styleUrls:   ['../bpmn-viewer.component/bpmn-viewer.component.scss', './bpmn-execution.component.scss']
})
export class BpmnExecutionComponent extends BpmnViewerComponent implements AfterViewInit {

  private latestSelectedNodeId;
  readonly latestSelection = 'latestSelection';
  constructor(protected renderer: Renderer2,
              protected el: ElementRef,
              protected bpmnViewerService: BpmnViewerService,
              protected guidedBoxService: BpmnGuidedBoxService,
              protected store$: Store<State>,
              protected _changeDetector: ChangeDetectorRef,
              protected userClicksElementsService: UserClicksElementsService,
              protected messageService: MessageService,
              protected testService: TestService
              ) {
    super(renderer, el, bpmnViewerService, guidedBoxService, store$, _changeDetector, userClicksElementsService, messageService,testService);
  }
  @Input() hideBpmnLogo: boolean = true;

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.store$.pipe(select(selectLatestSelectedNodeId)).
      takeUntil(this.destroyed$.asObservable()).
      withLatestFrom(this.store$.pipe(select(selectGetBpmnXmlParsingStatus))).
      filter(([nodeId, status]) => status === BP_Status.Completed).
      subscribe(([nodeId, status]) => this.updateLatestSelectedNodeId(nodeId));
    this.onElementClick();
  }

  onElementClick() {
    this.viewer.get(InjectionNames.eventBus).on('element.click', event => this.handleUserSelection(event));
  }

  handleUserSelection(event: any | undefined) {
    this.store$.pipe(select(selectGetUserSelectionStatus))
      .take(1)
      .subscribe((status) => {
        if (status !== USER_SELECTION_STATUS.InProgress) {
          const action = this.userClicksElementsService.getAppropriateAction(this.executionPath, event.element, this.nodesSelectionMode);
          if (action) {
            this.store$.dispatch(new UpdateLatestSelectedNodeIdAction({id: event.element.id}));
            this.store$.dispatch(new UpdateUserSelectionStatusAction({status: USER_SELECTION_STATUS.InProgress}));
            this.store$.dispatch(action);
          }
        }
      });
  }

  private updateLatestSelectedNodeId(nodeId: string) {
    if (!!nodeId && this.latestSelectedNodeId !== nodeId) {
      this.updateLatestSelectionClass(nodeId);
    }
  }

  private updateLatestSelectionClass(nodeId: string) {
    if (!!this.latestSelectedNodeId) {
      this.updateElementsCssClasses(this.removeCssClassMethodName,        [this.latestSelectedNodeId], this.latestSelection);
    }
    this.updateElementsCssClasses(this.addCssClassMethodName, [nodeId], this.latestSelection);
    this.latestSelectedNodeId = nodeId;
  }
}
